<template>
  <div>
    <div class="mt-5" v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!respostas.length && !loading" align="center" class="body-1 mt-5">
      Nenhuma resposta encontrada
    </div>
    <v-list v-if="!loading">
      <template v-for="(resposta, index) in respostas">
        <px-cotacao-resposta-view-produto-fornecedores-item :key="resposta.id"
                                                            :cotacao-produto="cotacaoProduto"
                                                            :cotacao-id="cotacaoId"
                                                            :resposta="resposta"
                                                            :is-modal-view="isModalView"/>
        <v-divider v-if="showDivider(index)" :key="`v-div${index}`"/>
      </template>
    </v-list>
  </div>
</template>

<script>
import RespostaService from '@/modules/cotacao/resposta/resposta-service';
import CotacaoRespostaViewProdutoFornecedoresItem
  from './CotacaoRespostaViewProdutoFornecedoresItem.vue';

export default {
  props: {
    searchText: String,
    selectedSort: Object,
    cotacaoId: {
      type: [String, Number],
      required: true,
    },
    cotacaoProduto: Object,
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      respostas: [],
    };
  },
  computed: {
    showDivider() {
      return index => index !== (this.respostas.length - 1);
    },
  },
  methods: {
    getRespostas() {
      this.loading = true;
      const query = this.buildQuery();
      RespostaService.getRespostasProdutos(this.cotacaoId, {
        query,
      })
        .then((response) => {
          this.respostas = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildQuery() {
      let filter = `cotacaoProduto.id = ${this.cotacaoProduto.id}`;

      const stringFilter = this.buildFilter();
      if (stringFilter) {
        filter = `${filter} and ${stringFilter}`;
      }

      return `${filter} ${this.buildSort()}`.trim();
    },
    buildFilter() {
      if (!this.searchText) {
        return '';
      }
      return `fornecedor.nome like "%${this.searchText.toLowerCase()}%"`;
    },
    buildSort() {
      if (!this.selectedSort) {
        return '';
      }
      return `order by ${this.selectedSort.value}`;
    },
  },
  watch: {
    searchText(newText, oldText) {
      if (newText === oldText) {
        return;
      }
      this.getRespostas();
    },
    selectedSort(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getRespostas();
    },
  },
  created() {
    this.getRespostas();
  },
  components: {
    pxCotacaoRespostaViewProdutoFornecedoresItem: CotacaoRespostaViewProdutoFornecedoresItem,
  },
};
</script>
